import {
    ICenterRoles,
    IEducation,
    IPagedData,
    IPagedSearch,
    ISecurityClearance,
    IUser,
    IUserCreate,
    IUserTable,
    TableStatus,
} from '@evencel/models';
import {Selectable} from '@evencel/ui';

export class GetUser {
    public static readonly type = '[User] GetUser';
    constructor(public id: string, public projection?: string) {}
}

export class ActivateUser {
    public static readonly type = '[User] ActivateUser';
    constructor(public user: IUserTable) {}
}

export class SearchUsers {
    public static readonly type = '[User] SearchUsers';
    constructor(public data: IPagedSearch) {}
}

export class AddSecurityClearence {
    public static readonly type = '[User] AddSecurityClearence';
    constructor(public data: ISecurityClearance) {}
}

export class GetSecurityClearence {
    public static readonly type = '[User] GetSecurityClearence';
}

export class CreateUser {
    public static readonly type = '[User] SaveUser';
    constructor(public user: IUserCreate) {}
}

export class UpdateUser {
    public static readonly type = '[User] UpdateUser';
    constructor(public user: IUser) {}
}

export class DeleteUser {
    public static readonly type = '[User] DeleteUser';
    constructor(public user: IUserTable) {}
}

export class RestoreUser {
    public static readonly type = '[User] RestoreUser';
    constructor(public user: IUserTable) {}
}

export class GetUsersResponse {
    public static readonly type = '[User] GetUsersResponse';
    constructor(public pagedData: IPagedData<IUser>, public status: TableStatus) {}
}

export class CenterRolesSelected extends Selectable<ICenterRoles[]> {
    public static readonly type = '[User] CenterRolesSelected';
    constructor(public override item: ICenterRoles[], public override durty = false) {
        super(item);
    }
}

export class CenterRolesDeselect extends Selectable<ICenterRoles> {
    public static readonly type = '[User] CenterDeselect';
    constructor(public override item: ICenterRoles) {
        super(item);
    }
}

export class GetUserResponse {
    public static readonly type = '[User] GetUserResponse';
    constructor(public user: IUser) {}
}

export class UpsertContinuingEducation {
    public static readonly type = '[User] AddContinuingEducation';
    constructor(public education: IEducation) {}
}

export class DeleteContinuingEducation {
    public static readonly type = '[User] DeleteContinuingEducation';
    constructor(public education: IEducation) {}
}

export class GetUserGeneral {
    public static readonly type = '[User] GetUserGeneral';
    constructor(public id: string) {}
}

export class GetUserGeneralResponse {
    public static readonly type = '[User] GetUserGeneralResponse';
    constructor(public user: unknown) {}
}

export class GetUserSecurityEntities {
    public static readonly type = '[User] GetUserSecurityEntities';
    constructor(public id: string) {}
}

export class GetUserSecurityEntitiesResponse {
    public static readonly type = '[User] GetUserSecurityEntitiesResponse';
    constructor(public data: unknown) {}
}
